/**
 * Parses a date string and returns a date-only display string via `Date`.
 * Central place to adjust locale or style for glass widget stat dates.
 */
export function formatDateOnly(value: string | null | undefined, fallback = '—'): string {
  if (value === null || value === undefined || value === '') return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

/**
 * Prefer a non-empty trimmed API display string when present; otherwise format `iso` with {@link formatDateOnly}.
 * Used for milestone/join dates, last booking, and similar dashboard fields that expose both `*_display` and raw values.
 */
export function milestoneDateDisplay(display: string | null | undefined, iso: string | null | undefined): string {
  const t = display?.trim();
  if (t) return t;
  return formatDateOnly(iso);
}

/** True when a milestone-style field has a real date to show (non-empty display or parseable ISO). */
export function milestoneHasValue(display: string | null | undefined, iso: string | null | undefined): boolean {
  if (display?.trim()) return true;
  if (iso === null || iso === undefined || iso === '') return false;
  return !Number.isNaN(new Date(iso).getTime());
}
